import Vue from 'vue';

Vue.component('vuetable-reimbursement', () =>
    import(/* webpackChunkName: 'reimbursement-index' */ './vuetable-reimbursement.vue'),
);
